// @import dependencies
import React, { CSSProperties } from 'react'
import { Modal } from 'react-bootstrap';
// @end dependencies

// @import components
import ForumForm from 'app_components/modules/admin/forum';
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalFormForum.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
// @end styles

interface IModalFormForumProps {
  open: boolean
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  hideCloseButton?: boolean
  saveCreatedBy?: boolean
  onClose?: (response?: {created?: boolean, response?: any})=>any
}

const ModalFormForum: React.FC<IModalFormForumProps> = (props) => {

  /**
   * @INFO Click en cerrar
   */
  const handleClickClose = () => {
    if(props.onClose){
      props.onClose()
    }
  }

  const handleForumCreated = (response: any) => {
    if (props.onClose) {
      props.onClose({
        response,
        created: true
      })
    }
  }

  return(
    <Modal
      className={`modal-learning-path-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <div
          className={`modal_form_forum-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
        >
          <TextComponent
            type='subtitle'
          >
            Nuevo foro
          </TextComponent>
          <ForumForm
            onHandleSubmit={handleForumCreated}
            viewer={false}
            defaultLocation='teacher'
            saveCreatedBy
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalFormForum;
